import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export const useServiceCarStore = create(
  persist(
    (set, get) => ({
      carInfo: {},
      setCarInfo: (carInfo) =>
        set(() => {
          // console.log(carInfo);
          return { carInfo };
        }),
    }),
    {
      name: 'car-info',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
